import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../common/Icons';
import CategoryLink from '../CategoryLink/CategoryLink';
import { StyledWrapper } from '../common/Wrapper/Wrapper.styles';
import useScreenSize from '../../core/hooks/useScreenSize';
import {
  StyledContainer,
  StyledHeading,
  StyledLike,
  StyledSubtitle,
  StyledTitle,
  StyledImageContainer,
  StyledDescription,
  StyledLink,
  StyledTextContainer,
} from './CompleteExperience.styles';

function CompleteExperience({ data }) {
  const [size] = useScreenSize();

  // TODO: Delete block of code, from this:

  const [experienceId, setExperienceId] = useState(null);
  const [isLiked, setIsLiked] = useState(false);

  const updateIsLikeState = () => {
    JSON.parse(localStorage.getItem('likedExperiences')).indexOf(experienceId) !== -1
      ? setIsLiked(true)
      : setIsLiked(false);
  };

  useEffect(() => {
    data.experienceId && setExperienceId(data.experienceId);
    updateIsLikeState();
  }, [experienceId]);

  const onLikeClick = () => {
    if (experienceId === null) return;

    const storage = JSON.parse(localStorage.getItem('likedExperiences'));
    if (storage.some(item => item === experienceId)) {
      if (storage.indexOf(experienceId) !== -1) {
        storage.splice(storage.indexOf(experienceId), 1);

        localStorage.setItem('likedExperiences', JSON.stringify(storage));

        return updateIsLikeState();
      }
    } else {
      storage.push(experienceId);

      localStorage.setItem('likedExperiences', JSON.stringify(storage));

      return updateIsLikeState();
    }
  };

  // TODO: To this, and delete local storage funcitonality at all

  if (!Object.entries(data).length) return null;

  return (
    <StyledContainer>
      <StyledWrapper>
        {size > 991
          ? data.img && (
              <StyledImageContainer>
                <img src={data.img.src} alt={data.img.alt} />
              </StyledImageContainer>
            )
          : null}
        <StyledTextContainer>
          {data.subtitle && <StyledSubtitle>{data.subtitle}</StyledSubtitle>}
          <StyledHeading>
            {data.instructor && <StyledTitle>{data.instructor}</StyledTitle>}
            <StyledLike onClick={onLikeClick}>
              {isLiked ? <Icon.HeartBig aria-hidden /> : <Icon.HeartOutline aria-hidden />}
            </StyledLike>
          </StyledHeading>
          {data.category && (
            <CategoryLink
              link={data.category.link}
              name={data.category.name}
              color={data.category.color}
            />
          )}
          {size < 992
            ? data.img && (
                <StyledImageContainer>
                  <img src={data.img.src} alt={data.img.alt} />
                </StyledImageContainer>
              )
            : null}
          {data.description && <StyledDescription>{data.description}</StyledDescription>}
          {data.link && <StyledLink to={data.link}>{data.button || 'Go to experience'}</StyledLink>}
        </StyledTextContainer>
      </StyledWrapper>
    </StyledContainer>
  );
}

CompleteExperience.propTypes = {
  data: PropTypes.shape({
    subtitle: PropTypes.string,
    instructor: PropTypes.string,
    liked: PropTypes.bool,
    category: PropTypes.shape({
      name: PropTypes.string,
      color: PropTypes.string,
    }),
    img: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    }),
    description: PropTypes.string,
    link: PropTypes.string,
    button: PropTypes.string,
  }),
};

CompleteExperience.defaultProps = {
  data: {},
};

export default CompleteExperience;
